module.exports = __webpack_public_path__ + "static/media/ibd_hips1.fb155042.png";